export default "__VITE_ASSET__8c53615b__"